var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{class:_vm.computedClasses,attrs:{"color":_vm.tile ? 'white' : _vm.color,"x-small":_vm.extraSmall,"small":_vm.small,"medium":_vm.medium,"large":_vm.large,"x-large":_vm.extraLarge}},[_vm._v(" "+_vm._s(_vm.icon)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }